/**
 * @generated SignedSource<<8214544c85e6f7ce15170476b8a61f45>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "accountId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "accountId",
    "variableName": "accountId"
  }
],
v2 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "totalCount",
    "storageKey": null
  }
],
v3 = {
  "alias": "ccCount",
  "args": [
    {
      "kind": "Literal",
      "name": "condition",
      "value": {
        "psType": 0
      }
    }
  ],
  "concreteType": "PaymentSourceTsConnection",
  "kind": "LinkedField",
  "name": "paymentSourceTsByAccountId",
  "plural": false,
  "selections": (v2/*: any*/),
  "storageKey": "paymentSourceTsByAccountId(condition:{\"psType\":0})"
},
v4 = {
  "alias": "achCount",
  "args": [
    {
      "kind": "Literal",
      "name": "condition",
      "value": {
        "psType": 1
      }
    }
  ],
  "concreteType": "PaymentSourceTsConnection",
  "kind": "LinkedField",
  "name": "paymentSourceTsByAccountId",
  "plural": false,
  "selections": (v2/*: any*/),
  "storageKey": "paymentSourceTsByAccountId(condition:{\"psType\":1})"
},
v5 = {
  "alias": "prCount",
  "args": [
    {
      "kind": "Literal",
      "name": "condition",
      "value": {
        "psType": 3
      }
    }
  ],
  "concreteType": "PaymentSourceTsConnection",
  "kind": "LinkedField",
  "name": "paymentSourceTsByAccountId",
  "plural": false,
  "selections": (v2/*: any*/),
  "storageKey": "paymentSourceTsByAccountId(condition:{\"psType\":3})"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "FundingSourcesQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "AccountT",
        "kind": "LinkedField",
        "name": "accountTByAccountId",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "FundingSourcesQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "AccountT",
        "kind": "LinkedField",
        "name": "accountTByAccountId",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "nodeId",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "a7700204aeaa71ffa1a765caac857161",
    "id": null,
    "metadata": {},
    "name": "FundingSourcesQuery",
    "operationKind": "query",
    "text": "query FundingSourcesQuery(\n  $accountId: UUID!\n) {\n  accountTByAccountId(accountId: $accountId) {\n    ccCount: paymentSourceTsByAccountId(condition: {psType: 0}) {\n      totalCount\n    }\n    achCount: paymentSourceTsByAccountId(condition: {psType: 1}) {\n      totalCount\n    }\n    prCount: paymentSourceTsByAccountId(condition: {psType: 3}) {\n      totalCount\n    }\n    nodeId\n  }\n}\n"
  }
};
})();

node.hash = "a152b8085cdabd2630df0724854568ae";

module.exports = node;
